// MyCarousel.js
import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.css';
import IndustriesWeServe from './components/IndustriesWeServe';
import Product from "./components/Product"
import Carousel from './components/Carousel';
import WhatNvisonOffers from './components/WhatNvisionOffers';
import VideoContainer from './components/VideoContainer';
import CaseStudies2 from './components/CaseStudies';
import Applications from './components/Applications';
import WhyNvision from './components/WhyNvision';
import AboutUs from './components/AboutUs';
import Navbar from './Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Contact from './components/Contact';

const LandingPage = () => {
  return (
    <>
      <Navbar/>
      <Carousel />
      <WhatNvisonOffers />
      <div className='features'>
        <WhyNvision />
      </div>
      <div className="appvid">
        <IndustriesWeServe />
        <VideoContainer/>
      </div>
      <Applications />
      <Product />
      <div className='case-studies'>
        <CaseStudies2 />
      </div>
      <AboutUs />
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}
export default App;
